import { UsersIcon } from 'lucide-react';
import { capitalize } from 'lodash';

import { type IEscrowInvitation } from 'src/graphql/schema';
import { Table, TableBody, TableCell, TableRow } from '@/components/ui/table';
import { Button } from '@/components/ui/button';

import { useParty } from '../model';

import SummaryCard from './SummaryCard';

type Props = {
  escrowInvitation: Pick<IEscrowInvitation, 'companyName' | 'userName' | 'userEmail'>;
};

const BeneficiaryInvitationCard = ({ escrowInvitation }: Props) => {
  const { type, onEdit } = useParty();

  const rows = [
    { id: 'organization-name', label: 'Organization name', value: escrowInvitation?.companyName },
    { id: 'contact-name', label: 'Primary contact name', value: escrowInvitation?.userName },
    { id: 'contact-email', label: 'Primary contact email', value: escrowInvitation?.userEmail },
  ];

  return (
    <SummaryCard
      icon={UsersIcon}
      title={`${capitalize(type)} information`}
      description="The primary point of contact who'll be invited to confirm their own details."
      action={
        <Button variant="secondary" size="sm" onClick={onEdit}>
          Edit
        </Button>
      }
    >
      <Table>
        <TableBody>
          {rows.map(({ id, label, value }) => (
            <TableRow key={id} className="border-0 hover:bg-white">
              <TableCell className="h-10 px-0 w-40 text-xs font-semibold text-muted-foreground py-2.5">
                {label}
              </TableCell>
              <TableCell data-separator className="h-10 w-5 px-0 pr-1 py-2.5 text-slate-400 text-right">
                :
              </TableCell>
              <TableCell className="h-10 py-2.5">
                <div className="min-w-47.5">{value}</div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </SummaryCard>
  );
};

export default BeneficiaryInvitationCard;
